import { render, staticRenderFns } from "./Wp_share_poster_only_img.vue?vue&type=template&id=04fb33d4&scoped=true&"
import script from "./Wp_share_poster_only_img.vue?vue&type=script&lang=js&"
export * from "./Wp_share_poster_only_img.vue?vue&type=script&lang=js&"
import style0 from "./Wp_share_poster_only_img.vue?vue&type=style&index=0&id=04fb33d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb33d4",
  null
  
)

export default component.exports